import logoUrl from "../assets/fmc-logo.webp";

/** FMC lockup with a product wordmark beneath it. */
export function Brand({
  logoHeight = 52,
  align = "left",
  wordmark = "Leads Manager",
  tone = "light",
}: {
  logoHeight?: number;
  align?: "left" | "center";
  wordmark?: string;
  tone?: "light" | "dark";
}) {
  const dark = tone === "dark";
  return (
    <div className={`flex flex-col ${align === "center" ? "items-center" : "items-start"}`}>
      <img
        src={logoUrl}
        alt="FMC — Connecting Dentistry"
        style={{ height: logoHeight, ...(dark ? { filter: "brightness(0) invert(1)" } : {}) }}
        className="w-auto"
      />
      <div
        className={`mt-2.5 pt-2.5 border-t w-full ${dark ? "border-white/20" : "border-default"} ${
          align === "center" ? "text-center" : "text-left"
        }`}
      >
        <span
          className={`text-[13px] font-bold tracking-[0.18em] uppercase ${
            dark ? "text-white" : "text-primary"
          }`}
        >
          {wordmark}
        </span>
      </div>
    </div>
  );
}
